import React from "react";
import { IoArrowBackOutline } from "react-icons/io5"

const BackButton = ({size, color}) => {
    return <IoArrowBackOutline size={size} color={color}/>
}

export default BackButton;